export { Page as default } from '@ui/views/card-cronos';
export { getStaticProps } from '@ui/views/card-cronos/getStatic';
